export const expandRightMenu = tab => ({
    type: 'EXPAND_RIGHT_MENU',
    tab
});

export const hideRightMenu = () => ({
    type: 'HIDE_RIGHT_MENU'
});

export default (state = {expanded: false, tab: ''}, action = {}) => {
    switch (action.type) {
        case 'EXPAND_RIGHT_MENU':
            return {expanded: true, tab: action.tab};
        case 'HIDE_RIGHT_MENU':
            return false;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/state/expandRightMenu.js